import React, { forwardRef } from 'react'
import { ReactComponent as CheckIcon } from '../../../assets/icons/check.svg'
import s from './index.module.scss'
import classNames from 'classnames'

interface IProps extends React.HTMLProps<HTMLInputElement> {
	label?: string
	filled?: boolean
}

const Checkbox = forwardRef<HTMLInputElement, IProps>(({ label, filled, ...props }, ref) => {
	return (
		<label className={s.wrapper}>
			<input ref={ref} type="checkbox" className={s.input} {...props} />
			<span className={classNames(s.check, { [s.filled]: filled })}>
				<CheckIcon />
			</span>
			{label && <span className={s.label}>{label}</span>}
		</label>
	)
})

Checkbox.displayName = 'Checkbox'

export default Checkbox
